import { CloseIcon } from 'assets/icons/CloseIcon'
import { DropZone } from 'components/DropZone/DropZone'
import { Modal } from 'components/Modal/Modal'
import { getFoodDietaryTags } from 'features/food/foodSlice'
import { getUsersSimpleInfo, importUsers } from 'features/users(Employees)/usersSlice'
import useModalClose from 'hooks/useModalClose'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { getParams } from 'utils/helpers'

const IMPORT_HEADERS = [
  'First name',
  'Last name',
  'Username',
  'Phone',
  'Secondary phone',
  'Email',
  '',
  'Date of birth',
  'Gender',
  'Nationality',
  'National ID',
  'Marital status',
  'Dietary tags',
]

export const ImportEmployeesModal = ({ closeModal }: { closeModal: any }) => {
  const dispatch = useDispatch<AppDispatch>()
  useModalClose(closeModal)
  const [file, setFile] = useState<File>(null)
  const dietaryTags = useSelector((state: RootState) => state.food.dietaryTags?.data || [])

  useEffect(() => {
    dispatch(getFoodDietaryTags({ page: 1, limit: 200 }))
  }, [dispatch])

  const availableCodes = dietaryTags
    .filter((t) => t.active !== false)
    .map((t) => t.code)
    .filter(Boolean)

  const handleDownloadTemplate = () => {
    const codesHint = availableCodes.length
      ? `Available dietary tag codes: ${availableCodes.join(', ')}`
      : 'Dietary tags: enter one or more codes separated by commas (e.g. LOCAL, HALAL)'
    const rows = [
      ['Employee import template', '', '', '', '', '', '', '', '', '', '', '', codesHint],
      [
        'Required: First name, Last name, Username, Phone, Dietary tags (for workers)',
        '',
        '',
        '',
        '',
        '',
        '',
        'Optional',
        'm or f',
        '',
        '',
        'single or married',
        'Comma-separated codes',
      ],
      IMPORT_HEADERS,
    ]
    const csv = rows
      .map((row) =>
        row.map((cell) => `"${String(cell ?? '').replace(/"/g, '""')}"`).join(','),
      )
      .join('\n')
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = 'employees-import-template.csv'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
    URL.revokeObjectURL(url)
  }

  const handleSave = async () => {
    const resp = await dispatch(importUsers(file))
    if (resp.meta.requestStatus === 'fulfilled') {
      await dispatch(getUsersSimpleInfo(getParams({ location })))
      closeModal()
    }
  }

  return (
    <Modal black>
      <Flex column between center>
        <Flex mb='16' column gap='1rem' width='100%'>
          <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
            <TitleText weight='bold'> Import Employees</TitleText>
            <CursorPointer onClick={closeModal}>
              <CloseIcon />
            </CursorPointer>
          </Flex>
          <Flex width='100%' justcenter column center gap='1rem'>
            <BodyText style={{ marginTop: 30 }}>Import from file</BodyText>
            <OtherText grey>
              Workers require at least one dietary tag in column M (Dietary tags). Use
              comma-separated codes.
            </OtherText>
            {availableCodes.length > 0 && (
              <OtherText grey>Available codes: {availableCodes.join(', ')}</OtherText>
            )}
            <Button variant='secondary' onClick={handleDownloadTemplate}>
              Download template
            </Button>
            <DropZone file={file} setFile={setFile} />
          </Flex>
        </Flex>
        <Button disabled={!file} variant='primary' onClick={handleSave}>
          Save
        </Button>
      </Flex>
    </Modal>
  )
}
